<section class="pt-16 pb-8 px-container">    
    <h1 class="text-5xl md:text-6xl">The Making Teca</h1>
    <p class="lg:text-xl mt-8 w-3/4">
        Cosa vuol dire fare teatro? Come si realizza la magia attraverso la quale vanno in scena le emozioni e i
        sentimenti che animano la parte più profonda della nostra mente? <br />
        Il Teatro Colosseo si trasforma in laboratorio di saperi e di mestieri, rompendo la quarta parete e
        permettendo ai partecipanti di non essere solo spettatori passivi ma totalmente attivi nella fruizione e
        nell’elaborazione del teatro stesso.
    </p>
</section>

<app-slider [loop]="false" [navigation]="false"  [grabCursor]="true" [slidesPerView]="4" [spaceBetween]="'20px'" [sliderLength]="posts.length" [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': { slidesPerView: 2, spaceBetween: 20, }, '@1.00': { slidesPerView: 3, spaceBetween: 20, }, '@1.50': { slidesPerView: 4, spaceBetween: 20 }}" [titolo_padding]="'pt-16'">
    <swiper-slide [lazy]="true" *ngFor="let post of posts" class="cursor-pointer">
        <img [src]="(post.immagine + '?type=making-teca' | image)" alt="Post Making Teca" [routerLink]="'/making-teca/' + post.id">
    </swiper-slide>            
</app-slider>